import { useCallback, useEffect, useRef, useState } from "react";

export function useAnimatedSelection<T>() {
  const [value, setValue] = useState<T | null>(null);
  const [open, setOpen] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);
  useEffect(() => () => clearTimeout(timer.current), []);
  const select = useCallback((next: T | null) => {
    clearTimeout(timer.current);
    if (next !== null) {
      setValue(next);
      setOpen(true);
    } else {
      setOpen(false);
      timer.current = setTimeout(() => setValue(null), 320);
    }
  }, []);
  return [value, select, open] as const;
}
